<template>
    <div class="comment">
        <!--{{keyword}}-->
        <!--{{searchList}}-->

        <!--{{userId}}-->
        <!--{{favoriteList}}-->

        <div class="article-list-main">
            <div class="article-list-container">
                <el-card class="article-list-item-container" v-for="(item,index) in commentList" :key="index">
                    <div><h3>{{item.title}}</h3></div>
                    <div><h6>{{item.summary}}</h6></div>
                    <div><h6>我的评论：</h6><h4 style="color: #6495ED">{{item.content}}</h4></div>
                    <router-link :to="'/article/articleDetail/' + item.articleId" target="_blank">
                        <a @click="addViewCount(item.articleId)">查看详情</a>
                    </router-link>

                    <el-button style="float: right" @click="delComment(item.id)">删除该评论</el-button>
                </el-card>
            </div>

            <el-pagination
                    class="page"
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    @prev-click="handlePrevClick"
                    @next-click="handleNextClick"
                    :current-page="currentPage"
                    :page-sizes="[10 , 20, 30, 40 ,50 ,60]"
                    :page-size="30"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total=total>
            </el-pagination>

        </div>

    </div>
</template>

<script>
    import {addViewCount} from "@/api/post";
    import {listByUserId,delComment} from "@/api/comment";

    export default {
        name: "Comment",
        data(){
            return{
                userId:"",
                commentList:[],
                total:0,
                currentPage: 1,
                pageNum:1,
                pageSize:30,
                freshen:0,
            }
        },

        watch: {
            /*监听是否删除了*/
            freshen:{
                handler(){
                    this.getCommentList(this.userId,this.pageNum,this.pageSize);
                },
                immediate: true
            },
        },

        created() {
            this.userId = this.$store.state.user.userId;
            this.getCommentList(this.userId,this.pageNum,this.pageSize);
        },
        methods: {
            addViewCount(articleId){
                //文章流量数+1
                addViewCount(articleId).then();
            },

            handleSizeChange(val) {
                this.pageSize=val
                this.getCommentList(this.userId,this.pageNum,val)
            },
            handleCurrentChange(val) {
                this.pageNum=val
                this.getCommentList(this.userId,val,this.pageSize)
            },
            handlePrevClick(val){
                this.getCommentList(this.userId,val,this.pageSize)
            },
            handleNextClick(val){
                this.getCommentList(this.userId,val,this.pageSize)
            },

            //根据用户id获取所有评论列表
            getCommentList(userId,pageNum,pageSize){
                listByUserId(userId,pageNum,pageSize).then(response => {
                    if (response.code === 200){
                        this.commentList = response.rows;
                        this.total = response.total;
                    }else {
                        this.$message({
                            showClose: true,
                            message: response.msg,
                            type: 'error'
                        });
                    }
                });
            },

            //删除评论
            delComment(commentId) {
                this.$confirm('确定要删除该评论吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    delComment(commentId).then(response => {
                        if (response.code === 200){
                            this.$message({
                                showClose: true,
                                message: response.msg,
                                type: 'success'
                            });
                            this.freshen=this.freshen+1;
                        }else {
                            this.$message({
                                showClose: true,
                                message: response.msg,
                                type: 'error'
                            });
                        }
                    });
                }).catch(() => {
                    // this.$message({
                    //     type: 'info',
                    //     message: '已取消删除'
                    // });
                });
            }
        }
    }
</script>

<style scoped>
    .comment{
        width: 60%;
        margin: 0 auto;
        padding-bottom: 20px;
    }
    .page{
        float: right;
        margin-right: 30px;
    }

    .article-list-item-container {
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    }

    .article-list-item-container :hover{
        background: #f9f9f9;
    }

    .article-list-item :hover{
        color: #6495ED;
    }

    .article-list-item{
        text-decoration: none;
        color: black;
    }
</style>
